import { Grid, Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import _ from "lodash";
import React from "react";
import CrossIcon from "src/icons/CrossIcon";

interface ModalHeaderV2Props {
  title: string;
  onClose: () => void;
}

const ModalHeaderV2 = (props: ModalHeaderV2Props): JSX.Element => {
  const { title, onClose } = props;

  const formattedTitle = React.useMemo((): string => {
    // seperate title into chucks - name and code - seperate code from name by finding the () characters
    const titleChunked = title.replace("(", "").replace(")", "").split(" ");

    // last element in array is code
    const tokenCode = titleChunked.pop();

    // the rest in the chunked array is the token name
    const tokenName = titleChunked.join(" ");

    return `${_.startCase(tokenName)} (${tokenCode?.toUpperCase()})`;
  }, [title]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        height: "60px",
        width: "100%",
        backgroundColor: "#002035",
        padding: "0px 10px",
      }}>
      <Grid item container justifyContent="space-between" alignItems="center">
        {/* do not remove - important for spacing of grid items */}
        <Grid item></Grid>
        <Grid item>
          <Typography
            sx={{
              fontSize: "23px",
              fontWeight: 600,
              lineHeight: "18px",
              color: "#FFF",
            }}>
            {formattedTitle}
          </Typography>
        </Grid>

        <Grid item>
          <IconButton onClick={onClose}>
            <CrossIcon color="#ffffff" width="16px" height="16px" />
          </IconButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ModalHeaderV2;
